var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoXxkTvNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-tv-1346388",
    d: "M265.133,264H240.867a.865.865,0,0,0-.867.857v17.014a.865.865,0,0,0,.867.857h7.627v3.557h-.823a.857.857,0,1,0,0,1.714h10.7a.857.857,0,1,0,0-1.714h-.823v-3.514h7.583a.865.865,0,0,0,.867-.857V264.857a.865.865,0,0,0-.867-.857Zm-9.36,22.286h-5.547v-3.514h5.59v3.514Zm8.493-5.271H241.733v-15.3h22.533Z",
    transform: "translate(-240 -264)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXxkTvNew);
export default __webpack_public_path__ + "static/media/icoXXKTvNew.5f9d4bd2caa54f90a533de4030b131e8.svg";
export { ForwardRef as ReactComponent };